import { useState } from "react";
import { groupApi } from "../api/group.service";

export const useUpdateDiscount = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const mutation = async (group_id: string) => {
    try {
      setLoading(true);

      const response: any = await groupApi.updateDiscount(group_id);

      return {
        success: true,
        data: response?.data?.data,
        message: response?.data?.message,
      };
    } catch (err: any) {
      console.log("Update group discount failed:", err);

      return {
        success: false,
        data: null,
        message: err?.response?.data?.message || "Something wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    mutation,
    loading,
  };
};
